/* eslint-disable no-restricted-imports */
import * as Icons from '@ethings/icons';
import { useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { FeatureIcons } from '../../types';
import { CircleIcon } from './core';
import { DynamicIcon } from './dynamic';

export const PortalWidgetIcons: FeatureIcons = {
  ...Icons,
  AccountIcon: Icons.Briefcase,
  AccountTreeIcon: Icons.Network,
  AlertConditionsIcon: Icons.Flag,
  AlertIcon: Icons.Bell,
  AlertOffIcon: Icons.BellOff,
  AnalyticsIcon: Icons.BarChart2,
  AuthorizedAppIcon: Icons.Key,
  BatteryIcon: Icons.Battery0,
  CalendarIcon: Icons.Calendar,
  CameraContentIcon: Icons.Camera,
  CheckCircleIcon: Icons.CheckCircle,
  CircleIcon,
  CloudIcon: Icons.WeatherCloud,
  CloseIcon: Icons.X,
  ContractIcon: Icons.FileCheck,
  CreditCardIcon: Icons.CreditCard,
  CurrencyIcon: Icons.DollarSign,
  CustomerDealerIcon: Icons.User,
  DashboardIcon: Icons.Dashboard,
  DeleteIcon: Icons.Trash,
  DeviceIcon: Icons.Cpu,
  DeviceTypeIcon: Icons.Cpu,
  DiagnosticEnableIcon: Icons.On,
  DiagnosticIcon: Icons.Diagnostic,
  DownloadIcon: Icons.Download,
  DrizzleIcon: Icons.WeatherDrizzle,
  EngineIcon: Icons.Engine,
  FeatureMatrixIcon: Icons.Swap,
  FileTextIcon: Icons.FileText,
  FilterIcon: Icons.Filter,
  FlagIcon: Icons.Flag,
  FuelIcon: Icons.Fuel,
  GaugeIcon: Icons.Gauge,
  GeofenceIcon: Icons.Grid,
  GroupIcon: Icons.Menu,
  HazeIcon: Icons.Haze,
  HistoryIcon: Icons.History,
  InfoIcon: Icons.Info,
  InstallIcon: Icons.Install,
  InstallationTemplateIcon: Icons.Install,
  LastContactIcon: Icons.Radio,
  LeaseManagementIcon: Icons.Lease,
  LocationIcon: Icons.MapPin,
  LocationUnknownIcon: Icons.MapPinUnknown,
  MailIcon: Icons.Mail,
  MapIcon: Icons.MapSheet,
  MarketIcon: Icons.Market,
  ModuleIcon: Icons.Module,
  NavigationIcon: Icons.Navigation2,
  NightIcon: Icons.Moon,
  OdometerIcon: Icons.Gauge,
  OverviewIcon: Icons.House,
  PauseIcon: Icons.Pause,
  PersonAddIcon: Icons.UserAdd,
  PersonGroupAddIcon: Icons.Plus,
  PersonGroupIcon: Icons.Menu,
  PersonIcon: Icons.User,
  PersonTypeIcon: Icons.User,
  PlayIcon: Icons.Play,
  PointOfInterestIcon: Icons.Pin,
  PowerIcon: Icons.On,
  RainIcon: Icons.WeatherRain,
  RefreshIcon: Icons.Refresh,
  ReportsIcon: Icons.FileText,
  SaveIcon: Icons.Save,
  SearchIcon: Icons.Search,
  SecurityIcon: Icons.Shield,
  SelfClaimIcon: Icons.HandUp,
  SignOutIcon: Icons.Logout,
  SnowIcon: Icons.WeatherSnow,
  SpeedIcon: Icons.Gauge,
  StickerIcon: Icons.Scan,
  StopIcon: Icons.Stop,
  SunIcon: Icons.WeatherSun,
  SwapIcon: Icons.Swap,
  SystemManagementIcon: Icons.Lock,
  TemperatureIcon: Icons.Thermostat,
  ThingGroupAddIcon: Icons.Plus,
  ThingGroupIcon: Icons.Box,
  ThingIcon: Icons.Box,
  TimeIcon: Icons.Clock,
  ThunderIcon: Icons.WeatherThunder,
  TornadoIcon: Icons.Tornado,
  TrailerIcon: Icons.Trailer,
  TransfersIcon: Icons.Repeat,
  TruckIcon: Icons.Truck,
  UnknownWeatherIcon: Icons.WeatherUnknown,
  UserGroupIcon: Icons.Users,
  UserProfileIcon: Icons.UserProfile,
  UserRolesIcon: Icons.UserCheck,
  UsersManageIcon: Icons.UserTarget,
  VoltageIcon: Icons.Zap,
  WarningIcon: Icons.Warning,
  WaterIcon: Icons.Water,
  WeightIcon: Icons.Weight,
} as const;

interface PageIconProps {
  icon: ReactNode | undefined;
  size?: string;
}

interface IconProps {
  icon: ReactNode | undefined;
  size?: string;
}

export const PageIcon: FC<PageIconProps> = ({ icon, size }) => {
  const theme = useTheme();
  const iconSize = size || theme.heading.icon.size || '1.5rem';
  return <DynamicIcon icon={icon} size={iconSize} color={theme.heading.icon.color} />;
};

export const MenuIcon: FC<IconProps> = ({ icon }) => {
  const theme = useTheme();
  return <DynamicIcon icon={icon} size={theme.sidebar.icons.size} color={theme.sidebar.icons.color} />;
};

export const MapMarkerIcon: FC<IconProps> = ({ icon, size }) => {
  const theme = useTheme();
  return <DynamicIcon icon={icon} size={size} color={theme.palette.common.white} />;
};

